import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InteractiveIsometricSharedModule } from '@interactive-isometric-shared/interactive-isometric-shared.module';
import { SharedModule } from '@shared/shared.module';
import { OscReferenceAppCommonModule } from 'osc-reference-app-common';
import { RouterModule } from '@angular/router';
import { OscUtilsModule } from '@osc-utils/osc-utils.module';
import { DeficiencyFilterService } from './services/deficiency-filter.service';
import { pipes } from './pipes/index';
import { materialModules } from './material/index';
import { components } from './components';
import { DeficiencyService } from './services/deficiency.service';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    InteractiveIsometricSharedModule,
    ...materialModules,
    OscReferenceAppCommonModule,
    OscUtilsModule,
    ReactiveFormsModule,
    SharedModule,
    ...components,
    ...pipes,
  ],
  providers: [DeficiencyService, DeficiencyFilterService],
  exports: [...components],
})
export class DeficiencyModule {}
